import { Link } from 'react-router-dom'
import React from 'react'
import AppRoutes from '../../services/AppRoutes'
import CookiesStorageService from '../../services/CookiesStorageService'
import { getTenantAssets } from '../../utils/tenantHelper'

const LogoBtn = () => {
  const { displayName, logoUrlWhite } = getTenantAssets();

  return (
    <Link
      to={`${CookiesStorageService.getUserId() ? `${AppRoutes.home}` : '#'}`}
      style={styles.logoContainer}>
      <img src={logoUrlWhite} alt={displayName} style={styles.img} />
    </Link>
  )
}
const styles = {
  logoContainer: {
    textDecoration: 'none',
    fontSize: 'larger',
    color: '#fff',
    fontWeight: 'bolder',
    marginRight: { xs: '10px', sm: '30px' },
  },
  img: { maxWidth: '100px', marginTop: '8px' },

}
export default LogoBtn
